// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2bSxS","range":"MonthRangeSwitch_range__1mWGv","disabled":"MonthRangeSwitch_disabled__2CTKQ"};